import { IGatsbyImageDataArray } from '@et/types/ImageTypes'
import React from 'react'
import PatternBrushTip from './patternBrushTip'
interface IBrushData {
  img?: string,
  name: string
}
interface Props {
  brushImages: IGatsbyImageDataArray[]
  brushData: IBrushData[]
}

function PatternBrushes(props: Props) {
  const { brushData, brushImages } = props
  return (
    <div className='grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 md:mx-auto md:max-w-[700px] md:gap-y-10 md:gap-x-8 lg:max-w-[900px] xl:grid-cols-4 xl:max-w-[1200px]'>
      {brushData.map((brush, index) => {
        return (
          <PatternBrushTip
            key={index}
            gatsbyImage={brushImages[index]}
            {...brush}
          />
        )
      })}
    </div>
  )
}

export default PatternBrushes

